import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
/* stylelint-disable no-descending-specificity -- This rule breaks when you have multiple complex styles in one file. */

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { styleUtils } from '../styles';
import { onDesktop, onMobile } from '../styles/breakpoints';
import { grey200 } from '../styles/palette';
import { fromThemeColors } from '../Theme';
import { tableCheckboxCss, tableMobileCss } from './Table.styled';
var trMobileSelectableCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding-left: 28px;\n\tpadding-top: 4px;\n\tposition: relative;\n"])));
var trHoverCss = function trHoverCss(props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", " {\n\t\t:hover {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n"])), onDesktop, fromThemeColors('listItemHoverBackground')(props));
};
var trDesktopHeightCss = function trDesktopHeightCss(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", " {\n\t\theight: ", ";\n\t}\n"])), onDesktop, props.rowHeight);
};
export var StyledTR = styled.tr(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tcursor: default;\n\tbackground: ", ";\n\topacity: ", ";\n\t:focus {\n\t\toutline: none;\n\t\t", "\n\t}\n\t:active {\n\t\tbox-shadow: none;\n\t}\n\t", " {\n\t\tborder: 1px solid ", ";\n\t\t", ";\n\t}\n\t", ";\n\t", ";\n\t", ";\n"])), function (props) {
  return props.selected ? fromThemeColors('listItemSelectedBackground') : 'transparent';
}, function (props) {
  return props.inactive ? 0.5 : 1;
}, css(styleUtils.focusInsetThick), onMobile, grey200, function (props) {
  return props.selectable && trMobileSelectableCss;
}, tableMobileCss, function (props) {
  return props.rowHeight && trDesktopHeightCss;
}, function (props) {
  return props.hover && trHoverCss;
});
export var StyledTDCheckbox = styled.td(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t", ";\n"])), tableCheckboxCss);